export const PROFILE_TYPES = {
  employee: 'Employee',
  organization_admin: 'Admin',
  multi_admin: 'Broker',
  payroll_partner: 'Payroll Partner',
  employer_admin: 'Admin',
  provisional_admin: 'Admin',
  user: 'User',
}
export type UserProfileType = keyof typeof PROFILE_TYPES

export type AvailableProfileTypes = [UserProfileType, ...Array<UserProfileType>] // minimum length of 1

export type ProfileTypeContextType = {
  current: UserProfileType | null | undefined // current profile type (null = error/none, undefined = loading)
  setCurrent: (profileType: UserProfileType) => void // setter function
  available: AvailableProfileTypes | null | undefined // available profile types (null = error/none, undefined = loading)
}
